import Vue from "vue";
import Vuex from "vuex";
import store from "./store";

import DonationForm from "./views/DonationForm.vue";
import JoinForm from "./views/JoinForm.vue";
import ActionForm from "./views/ActionForm.vue";
import RenewalForm from "./views/RenewalForm/Index.vue";
import AuthForm from "./views/AuthForm.vue";
import ResetPasswordForm from "./views/ResetPasswordForm.vue";
import EventRegistrationForm from "./views/EventRegistrationForm/Index.vue";
import AlternateForm from "./views/AlternateForm.vue"

Vue.use(Vuex);

const components = [
  {
    component: DonationForm,
    element: "donation-form",
  },
  {
    component: JoinForm,
    element: "join-form",
  },
  {
    component: ActionForm,
    element: "action-form",
  },
  {
    component: RenewalForm,
    element: "renewal-form",
  },
  {
    component: AuthForm,
    element: "auth-form",
  },
  {
    component: ResetPasswordForm,
    element: "reset-password-form",
  },
  {
    component: EventRegistrationForm,
    element: "event-registration-form",
  },
  {
    component: AlternateForm,
    element: 'alternate-form'
  }
];

export default {
  loadComponents() {
    components.forEach(({ component, element }) => {
      // Is the custom element in the DOM?
      if (!document.querySelector(element)) {
        return;
      }

      // Create a new Vue instance and mount it to the custom element.
      new Vue({
        store: store,
        render: (createElement) => createElement(component),
      }).$mount(element);
    });
  },
};
